import styled from 'styled-components';

const SigninText = styled.p`
  color: #fff;
  font-size: 0.875rem;
  margin: 0;
`;

export default SigninText;
